import { FC, FormEvent } from 'react';
import styled from 'styled-components';
import logo from '../../assets/restore-logo.svg';
import Input from '../Input';
import Button from '../Button';

const Card = styled.section(({ theme }) => {
  const { color, shadow, type } = theme;

  return `
    font-family: ${type.face};
    background-color: ${color.grayscale[1000]};
    box-shadow: ${shadow.regular};
    display: flex;
    flex-flow: column nowrap;
    width: 90%;
    margin: 0 auto;
    border-radius: 16px;
    padding: 48px;
    align-items: center;

    @media screen and (min-width: 768px) {
      width: 700px;
    }
  `;
});

const Logo = styled.img`
  display: block;
  max-width: 300px;
`;

const Form = styled.form`
  display: block;
  width: 100%;
`;

const Heading = styled.h1(({ theme }) => {
  const { type } = theme;

  return `
    font-size: ${type.size.larger};
    width: 100%;
    text-align: left;
    margin: 1rem 0 1rem;
  `;
});

const Text = styled.div(({ theme }) => {
  const { type } = theme;

  return `
    font-size: ${type.size.regular};
    margin: 0 0 1rem;
  `;
});

const Paragraph = styled.p`
  margin: 0 0 1rem;
`;

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 1rem;
`;

export interface IForgotPassword {
  submitCallback: () => void;
  changeCallback: (text: string) => void;
  error?: string;
  email: string;
  submitDisabled: boolean;
  submitted: boolean;
}

const ForgotPasswordForm: FC<IForgotPassword> = ({
  submitCallback,
  changeCallback,
  error,
  email,
  submitDisabled,
  submitted,
}) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    submitCallback();
  };

  return (
    <Card>
      <Logo src={logo} alt="Restore Logo" />
      {submitted ? (
        <>
          <Heading>Request received</Heading>
          <Text>
            <Paragraph>
              If an account is found, an email has been sent to the email address you provided with a link to reset your
              password.
            </Paragraph>
            <Paragraph>
              If you did not receive an email, please contact an administrator for your Restore account.
            </Paragraph>
          </Text>
        </>
      ) : (
        <>
          <Heading>Forgot password</Heading>
          <Text>
            <Paragraph>
              Enter the email address associated with your account and we will send you a link to reset your password.
            </Paragraph>
          </Text>

          <Form onSubmit={handleSubmit}>
            <Input
              type="email"
              id="email"
              label="Email address"
              required
              value={email}
              onChange={(e) => changeCallback(e.currentTarget.value)}
              invalid={error ? true : false}
              errors={error}
            />

            <ButtonContainer>
              <Button type="submit" disabled={submitDisabled}>
                Send Reset Link
              </Button>
            </ButtonContainer>
          </Form>
        </>
      )}
    </Card>
  );
};

export default ForgotPasswordForm;
